<template>
  <div>
    <v-layout column>
      <v-flex md12 mt-3>
        <v-card>
          <v-card-title primary-title>
            <v-layout wrap>
              <v-flex md3>
                <v-select
                  :items="stays"
                  item-text="city"
                  item-value="id"
                  v-model="selectedStay"
                  label="Cidade"
                ></v-select>
              </v-flex>
              <v-flex md3>
                <v-select
                  :items="hotels"
                  v-model="selectedHotel"
                  label="Hotel"
                ></v-select>
              </v-flex>
              <v-flex md6>
                <v-select
                  :items="packagesForSelectedHotel"
                  v-model="selectedPackage"
                  item-text="name"
                  item-value="id"
                  label="Pacote"
                  clearable
                ></v-select>
              </v-flex>
            </v-layout>
          </v-card-title>
          <v-card-text>
            <v-layout wrap>
              <v-flex md12>
                <v-list
                  style="height: 300px; border: 1px solid;"
                  class="overflow-y-auto"
                >
                  <template
                    v-for="(passenger, index) in this.applicableToPassengers"
                  >
                    <v-list-item
                      @click="selectPassenger(passenger)"
                      :key="`passenger_${index}`"
                    >
                      <v-list-item-action>
                        <v-icon v-if="selectedPassengers.includes(passenger.id)"
                          >check_box</v-icon
                        >
                        <v-icon v-else>check_box_outline_blank</v-icon>
                      </v-list-item-action>
                      <v-list-item-content>
                        <v-list-item-title>
                          {{ passenger.customerName }}
                        </v-list-item-title>
                        <v-list-item-subtitle>
                          {{ passenger.packageName }}
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                    <v-divider :key="`divider_passenger_${index}`"></v-divider>
                  </template>
                </v-list>
              </v-flex>
              <v-flex md12>
                <v-toolbar color="transparent" dense flat>
                  <v-toolbar-side-icon
                    :disabled="selectedPassengers.length == 0"
                    @click="selectedPassengers = []"
                  >
                    <v-icon>clear</v-icon>
                  </v-toolbar-side-icon>
                  <v-toolbar-title class="body-2 grey--text">
                    {{ this.selectedPassengers.length }} de
                    {{ this.applicableToPassengers.length }} selecionados
                  </v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-toolbar-items>
                    <v-text-field
                      name="roomNumber"
                      label="Quarto"
                      id="roomNumber"
                      v-model="selectedRoom"
                      v-on:keyup.enter="addSelectedPassengersToRoom"
                    ></v-text-field>
                    <v-btn
                      color="primary"
                      :disabled="
                        !this.selectedRoom ||
                          this.selectedPassengers.length == 0
                      "
                      @click="addSelectedPassengersToRoom"
                      text
                      icon
                    >
                      <v-icon>check</v-icon>
                    </v-btn>
                  </v-toolbar-items>
                </v-toolbar>
              </v-flex>
              <v-flex md12>
                <v-list
                  style="height: 300px; border: 1px solid;"
                  class="overflow-y-auto"
                >
                  <template
                    v-for="(passenger, index) in this.allocatedPassengers"
                  >
                    <v-list-item :key="`allocated_passenger_${index}`">
                      <v-list-item-action
                        @click="removePassengerAllocation(passenger)"
                      >
                        <v-icon>delete</v-icon>
                      </v-list-item-action>
                      <v-list-item-content>
                        <v-list-item-title>
                          {{ passenger.customerName }}
                        </v-list-item-title>
                        <v-list-item-subtitle>
                          {{ passenger.packageName }}
                        </v-list-item-subtitle>
                      </v-list-item-content>
                      <v-list-item-action
                        >Quarto
                        {{ passenger.allocation.room }}</v-list-item-action
                      >
                    </v-list-item>
                    <v-divider
                      :key="`divider_allocated_passenger_${index}`"
                    ></v-divider>
                  </template>
                </v-list>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import api from "@/api";
export default {
  props: ["tripId", "passengers"],
  data() {
    return {
      packages: [],
      stays: [],
      selectedStay: null,
      selectedHotel: null,
      selectedPackage: null,
      selectedPassengers: [],
      selectedRoom: null,
      allocations: []
    };
  },
  computed: {
    hotels() {
      if (this.selectedStay == null) return [];

      var hotelNames = this.packages.map(p => {
        var names = p.stayDetails
          .filter(sd => sd.stayId == this.selectedStay)
          .map(sd => sd.hotelName);

        if (names.length > 0)
          names = names.reduce((allNames, hotelName) => [
            ...allNames,
            hotelName
          ]);

        return names;
      });

      //This will create a distinct list of items. Work for primitive types,
      //but will NOT work for complex objects
      //For more: https://codeburst.io/javascript-array-distinct-5edc93501dc4
      return [...new Set(hotelNames)];
    },
    packagesForSelectedHotel() {
      if (this.selectedHotel == null) return [];

      var packagesForHotels = this.packages.map(p => {
        var matchedStays = p.stayDetails.filter(
          sd =>
            sd.stayId == this.selectedStay && sd.hotelName == this.selectedHotel
        );

        if (matchedStays.length > 0) return p.id;
      });

      return [...new Set(packagesForHotels.filter(ph => ph != undefined))].map(
        ph => {
          return this.packages.filter(p => p.id == ph)[0];
        }
      );
    },
    applicableToPassengers() {
      if (!this.selectedHotel) return [];

      var packages =
        this.selectedPackage == null
          ? this.packagesForSelectedHotel
          : this.packagesForSelectedHotel.filter(
              p => p.id == this.selectedPackage
            );

      var stayIds = packages.map(
        _package =>
          _package.stayDetails
            .filter(sd => sd.hotelName == this.selectedHotel)
            .map(sd => sd.stayId)[0]
      );

      stayIds = [...new Set(stayIds.filter(s => s != undefined))];

      return this.passengers.filter(
        passenger =>
          packages.map(p => p.id).includes(passenger.packageId) &&
          (this.allocations.length == 0 ||
            this.allocations.filter(
              a => stayIds.includes(a.stayId) && a.passengerId == passenger.id
            ).length == 0)
      );
    },
    allocatedPassengers() {
      var packages =
        this.selectedPackage == null
          ? this.packagesForSelectedHotel
          : this.packagesForSelectedHotel.filter(
              p => p.id == this.selectedPackage
            );

      var stayIds = packages.map(
        _package =>
          _package.stayDetails
            .filter(sd => sd.hotelName == this.selectedHotel)
            .map(sd => sd.stayId)[0]
      );

      stayIds = [...new Set(stayIds)];

      return this.passengers
        .filter(
          passenger =>
            packages.map(p => p.id).includes(passenger.packageId) &&
            this.allocations.length > 0 &&
            this.allocations.filter(
              a => stayIds.includes(a.stayId) && a.passengerId == passenger.id
            ).length > 0
        )
        .map(passenger => {
          var allocation = this.allocations.filter(
            a => stayIds.includes(a.stayId) && a.passengerId == passenger.id
          )[0];
          return Object.assign(passenger, { allocation: allocation });
        });
    }
  },
  methods: {
    selectPassenger(passenger) {
      if (!this.selectedPassengers.includes(passenger.id)) {
        this.selectedPassengers.push(passenger.id);
      } else {
        this.selectedPassengers = this.selectedPassengers.filter(
          id => id != passenger.id
        );
      }
    },
    addSelectedPassengersToRoom() {
      if (!this.selectedRoom || this.selectedPassengers.length == 0) return;
      var allocations = this.selectedPassengers.map(passengerId => {
        var passenger = this.passengers.filter(p => p.id == passengerId)[0];
        var stayDetail = this.packages
          .filter(_package => _package.id == passenger.packageId)
          .map(
            _package =>
              _package.stayDetails.filter(
                sd => sd.hotelName == this.selectedHotel
              )[0]
          )[0];
        return {
          passengerId: passenger.id,
          stayId: stayDetail.stayId,
          room: this.selectedRoom
        };
      });

      this.allocations = this.allocations.concat(allocations);

      //Add remotely
      api
        .request(
          "POST",
          `/trips/${this.tripId}/organization/roomList`,
          allocations
        )
        .then(() => {
          console.log("Success");
        })
        .catch(error => {
          console.log(error);
        })
        .finally(() => {
          this.fetchAllocations();
        });

      this.selectedPassengers = [];
      this.selectedRoom = null;
    },
    removePassengerAllocation(passenger) {
      var indexToRemove = this.allocations.findIndex(
        a => a.passengerId == passenger.id && a.stayId == this.selectedStay
      );

      var allocationsToRemove = this.allocations.splice(indexToRemove, 1);

      //Remove remotely
      api
        .request(
          "DELETE",
          `/trips/${this.tripId}/organization/roomList`,
          allocationsToRemove
        )
        .then(() => {
          console.log("Success");
        })
        .catch(error => {
          console.log(error);
        })
        .finally(() => {
          this.fetchAllocations();
        });
    },
    fetchAllocations() {
      api
        .request("GET", `/trips/${this.tripId}/organization/roomList`)
        .then(response => {
          this.allocations = response.data.allocations || [];
        })
        .catch(error => {
          console.log(error);
        });
    }
  },
  mounted() {
    api
      .request("GET", `/trips/${this.tripId}/package`)
      .then(response => {
        var tripPackages = response.data.packages || [];
        tripPackages.forEach(p => {
          api
            .request("GET", `/trips/${this.tripId}/package/${p.id}`)
            .then(detailsResponse => {
              p.stayDetails = detailsResponse.data.stayDetails || [];
              this.packages.push(p);
            })
            .catch(error => {
              console.log(error);
            });
        });
      })
      .catch(error => {
        console.log(error);
      });
    api
      .request("GET", `/trips/${this.tripId}/stay`)
      .then(response => {
        this.stays = response.data.stays || [];
      })
      .catch(error => {
        console.log(error);
      });
    this.fetchAllocations();
  }
};
</script>
